Service = App.loadClass 'core::Angular/Service'

class exports.MapsUploadService extends Service
    constructor: (@http, @modal, @typeHelper) ->
        @options = null
        @file_extension = null
        @file_list = null
        @csq_id = null
        @validFiles = false

    getFileExtension: () =>
        @formatExtension(@file_extension)

    setFileExtension: (val) =>
        @file_extension = val if val?

    getTypes: () =>
        return @http.post 'backend/grower/maps-upload/get-types'

    getMakes: (upload_type) =>
        return @http.post 'backend/grower/maps-upload/get-makes', { upload_type }

    getProducts: (upload_type, make_id) =>
        return @http.post 'backend/grower/maps-upload/get-products', { upload_type, make_id }

    getFileTypes: (model_id) =>
        return @http.post 'backend/grower/maps-upload/get-file-types', { model_id }

    deleteTempFile: (file) =>
        base_name = file[0].name.split('.')[0]

        for index, object of @file_list
            _.remove @file_list, object if object.file.split('.')[0] is base_name

        @http.post('backend/grower/upload-controller/delete-temp-file', { name: file[0].name, csq_id: @csq_id })

    clearUpload: () =>
        @http.post('backend/grower/upload-controller/clear-upload')

    deleteCsqDirectory: () =>
        @http.post('backend/grower/upload-controller/delete-csq-directory', { csq_id: @csq_id }).then () =>
            @csq_id = null

    getFormatDescription: (id) =>
        return @http.post 'backend/grower/maps-upload/get-format-description', { id: id }

    extractFormat: (name) =>
        return name.split(' (')[0]

    formatExtension: (extension) =>
        return null if extension is null

        # Always want to allow zips
        return extension.replace(/\./g, '').replace(/\s/g, '') + ',zip'

    getTypeHelp: (type) =>
        @typeHelper.showTypeHelp(type)

    existingFiles: () =>
        return @http.post('backend/grower/upload-controller/existing-files')

    processUploads: (params) =>
        return @http.post('backend/grower/upload-controller/process-uploads', { params })

    finalizeUpload: () =>
        @http.post('backend/grower/upload-controller/finalize-upload',
            { file_list: @file_list, options: @options, csq_id: @csq_id })

    showDuplicateFileDialog: (duplicate_files) =>
        modal = @modal.open
            windowClass: 'modal-width'
            templateUrl: 'backend/grower/maps-upload/duplicate-file-dialog'
            controller: 'MapsUpload.Controllers.DuplicateFileDialogController'
            resolve:
                data: () =>
                    return 'files': duplicate_files

    showInvalidShapefileDialog: (invalid_files) =>
        modal = @modal.open
            windowClass: 'modal-width'
            templateUrl: 'backend/grower/maps-upload/invalid-shapefile-dialog'
            controller: 'MapsUpload.Controllers.InvalidShapefileDialogController'
            resolve:
                data: () =>
                    return 'data': invalid_files

    queueRemoval: (file_groups) =>
        removal_ids = []

        for index, file of file_groups
            base_name = file.filename.split('.')[0]
            for index, queue_file of @uploader.files
                removal_ids.push(queue_file.id) if queue_file.name.indexOf(base_name) isnt -1

        for index, id of removal_ids
            $("##{id}").remove()
            @uploader.removeFile(id)

    replaceDuplicateFiles: (file_list) =>
        return @http.post 'backend/grower/upload-controller/replace-duplicate-files', { file_list }

    getInputFilesProcessingStatus: (input_files_ids) =>
        return @http.post 'backend/grower/upload-controller/get-input-file-processing-status', { input_files_ids }
